const getters = {
  sidebar: state => state.app.sidebar,
  isShrinkage: state => state.app.isShrinkage,
  visitedViews: state => state.app.visitedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  status: state => state.user.status,
  roles: state => state.user.roles,
  menus: state => state.user.menus,
  elements: state => state.user.elements,
  setting: state => state.user.setting,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  
  userId: state => state.user.userId,
  distributorId: state => state.user.distributorId,
  companyId: state => state.user.companyId,
  currency: state => state.user.currency, //货币符号
  // password: state => state.user.password,

  isRouterAlive:state => state.app.isRouterAlive,
  tinymce: state => state.app.tinymce, //货币符号
};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js